import { HttpClient } from '../http/http-client';
import { ApiResponse } from './api-response';

export class HttpApiClient extends HttpClient {
  static responseType = 'json';

  /**
   * Default headers.
   *
   * @returns {HttpResponse}
   */
  static transformResponse(response, requestConfig) {
    const apiResponse = new ApiResponse(response, requestConfig);
    return apiResponse;
  }

  static defaultHeaders() {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    const authToken = localStorage.getItem(process.env.VUE_APP_JWT_BEARER);
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    return headers;
  }
}
